import React, { useState, useCallback, useEffect } from 'react'
import debounce from 'lodash.debounce'
import { Button, BUTTON_THEME, Icon, Chip, CHIP_TYPES } from '@st-operations/uikit/src/v2/index.js'

import MultiValueInput from '_components/multi-value-input/index.jsx'
import { logErrorAsync } from '_lib/utility.js'

const KeywordsInputWithRecommendations = ({ values, onChange, label }) => {
  const [similar, setSimilar] = useState([])

  const getKeywordsRecommendations = useCallback(
    debounce(async (keywords) => {
      if (keywords.length > 0) {
        try {
          const response = await fetch(
            'https://datasphere-search.sharethis.com?' +
              new URLSearchParams({
                query: keywords.join(','),
              }),
            {
              method: 'GET',
            }
          ).then((res) => res.json())
          setSimilar(
            response.keywords.filter((keyword) => !keywords.includes(keyword.name)).slice(0, 8)
          )
        } catch (error) {
          logErrorAsync(error)
          toast.error(error.message)
        }
      }
    }, 1000),
    []
  )

  useEffect(() => {
    const lastValue = values?.at(-1)
    if (!lastValue) {
      setSimilar([])
    }
    getKeywordsRecommendations(lastValue ? [lastValue] : [])
  }, [values])

  const handleAddKeyword = (value) => () => {
    setSimilar((prev) => prev.filter(({ name }) => name !== value))
    onChange([...values, value], 'terms')
  }

  const handleAddAll = () => {
    setSimilar([])
    onChange([...values, ...similar.map(({ name }) => name)], 'terms')
  }

  return (
    <>
      <MultiValueInput
        className="modal-attribute__keyword"
        label={label || 'Terms'}
        name="terms"
        values={values}
        onChange={onChange}
      />
      <If condition={values?.length > 0}>
        <div className="modal-attribute__similar-terms">
          <p className="modal-attribute__keyword-title">Similar {label || 'terms'}</p>
          <div className="modal-attribute__keyword-container">
            <For each="term" of={similar}>
              <Chip
                key={`${term.name}-${term._id}`}
                value={term.name}
                onClick={handleAddKeyword(term.name)}
                onButtonClick={handleAddKeyword(term.name)}
                small
                hasAddIcon
                type={CHIP_TYPES.FILL}
                className="modal-attribute__keyword-chip"
                iconStyle={{ fill: 'currentColor' }}
              />
            </For>
          </div>
          <Button onClick={handleAddAll} theme={BUTTON_THEME.GRAY} className="topics-card__add-all">
            <Icon icon="plus2" type="fill" width="16px" height="16px" color="#3D3D3D" />
            Add all similar terms
          </Button>
        </div>
      </If>
    </>
  )
}

export default KeywordsInputWithRecommendations
